var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCirclePlus = function SvgCirclePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.005 18.532c4.583 0 8.333-3.746 8.333-8.324s-3.75-8.323-8.333-8.323-8.333 3.745-8.333 8.323 3.75 8.324 8.333 8.324M6.672 10.207h6.667M10 13.538v-6.66"
  })));
};
export { SvgCirclePlus as ReactComponent };
export default __webpack_public_path__ + "5ac036f5296c08ca8bd969f8140cfc54.svg";